// Hackle 실험 인프라 상수 - platform goi_common(GoiHackleDevtools.tsx)과 동일 값 유지.
// 값이 갈리면 dev 오버라이드 localStorage가 레포별로 호환되지 않으니 바꾸지 말 것.
export const HACKLE_VARIATIONS = ["A", "B", "C", "D", "Z"] as const;
export const HACKLE_DEVTOOLS_STORAGE_KEY = "local_test_variations";

export const REGISTERED_EXPERIMENTS_KEY = "local_registered_experiments";

// 미확정/미할당 sentinel. SDK 기본값 "A"를 쓰면 "로딩 중"과 "대조군 배정"이 구분되지 않는다.
// platform과 동일하게 "Z"를 default로 넘긴다.
export const HACKLE_UNASSIGNED_VARIATION = "Z";

// useCustomVariation이 dev/preview에서 호출한 실험 key를 적재한다. Devtools 패널이 이 목록을
// 읽어 토글 UI를 그린다. 패널이 열려 있는 동안 새 실험이 감지되면 커스텀 이벤트로 알린다.
export const EXPERIMENT_REGISTERED_EVENT = "hackle-experiment-registered";

export const getRegisteredExperiments = (): number[] => {
  if (typeof window === "undefined") return [];

  const stored = window.localStorage.getItem(REGISTERED_EXPERIMENTS_KEY);
  if (!stored) return [];

  try {
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    // 손상된 값이면 빈 목록으로 시작. platform 원본은 registerExperiment 쪽 parse가
    // try/catch 밖에 있어서 손상 시 예외를 던진다. 읽기를 이 함수 하나로 모아 막았다.
    return [];
  }
};

export const registerExperiment = (experimentKey: number) => {
  if (typeof window === "undefined") return;

  const experiments = getRegisteredExperiments();
  if (experiments.includes(experimentKey)) return;

  window.localStorage.setItem(
    REGISTERED_EXPERIMENTS_KEY,
    JSON.stringify([...experiments, experimentKey])
  );
  window.dispatchEvent(new Event(EXPERIMENT_REGISTERED_EVENT));
};
